<!--
采购控制台
-->

<template>
    <div>
        <!-- 搜索栏 -->
        <order-search
                :count-data="countTagData"
                :refresh-url="defaultUrl"
                :handle-success="setHandleResponse"
                :handle-re-fresh="setHandleResponse">
            <el-col :span="1">
                 <div>
                    <i style="margin-right: 10px;float: left" class="el-icon-loading" v-show="loading"></i>
                </div>
            </el-col>
            <el-col :span="2">
                <div>
                    <el-tag style="margin-right: 10px;float: left" type="info" size="small">订单数量 {{ orders.length }} / {{
                        count }}
                    </el-tag>
                </div>
            </el-col>
        </order-search>

        <!-- order 内容列表 -->
        <order-table :sort-url="defaultUrl" @handlesort="setHandleResponse" :clickModify="clickMdf" :showModify="true"
                     :orders="orders"/>

        <!-- 加载下一页 -->
        <next-foo :next-url="nextUrl" :handle-response="handleResponse"/>

        <!-- order 修改组件 -->
        <order-apply-modify ref="orderApplyModify"/>


    </div>
</template>

<script>
    import OrderSearch from "../components/orders/OrderSearch"
    import OrderTable from "../components/orders/OrderTable"
    import NextFoo from "../components/NextFoo"
    import OrderApplyModify from "../components/orders/OrderApplyModify"

    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: "OrderApply",
        components: {OrderApplyModify, NextFoo, OrderSearch, OrderTable},
        data() {
            const rootUrl = `${this.$const.orderListUrl}?&ordering=id`
            return {
                loading: false,     // 是否显示初始加载时动画

                // 默认的加载数据接口 用于初始化与刷新
                defaultUrl: `${rootUrl}&applyinfo__finish=false`,

                // 加载下一页的接口地址
                nextUrl: '',

                // 获取的订单数量 [不一定都加载出来]
                count: 0,

                modHandleMap: new Map([
                    ['add', this.addApplyOrders],
                    ['set', this.setApplyOrders],
                ]),

                // 组件管理器
                componentManager: {
                    orderApplyModifyComponent: null, //  <order-apply-modify ref="orderApplyModify"/> 组件对象
                    orderAMC: null,                  // orderApplyModifyComponent 的简称 与上面的效果一致
                },

                // 快捷标签的配置数据
                countTagData: {
                    countTagsUrl: `${this.$const.orderListUrl}applyinfo_counts/`,
                    dataArr: [
                        {
                            tagName: '已完成: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&applyinfo__finish=true`,
                            countKey: 'finished',
                            type: 'success'
                        },
                        {
                            tagName: '待处理: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&applyinfo__finish=false`,
                            countKey: 'un_finish',
                            type: 'danger'
                        },
                        {
                            tagName: '加急: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&applyinfo__finish=false&urgent=true`,
                            countKey: 'urgent',
                            type: 'danger'
                        },
                        {
                            tagName: '面料未完成: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&applyinfo__finish=false&un_applyinfo__current=FINISH`,
                            countKey: 'un_material',
                            type: 'danger'
                        },
                        {
                            tagName: '辅料未完成: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&applyinfo__finish=false&un_applyinfo__sub_current=FINISH`,
                            countKey: 'un_sub_material',
                            type: 'danger'
                        },
                    ],
                },
            }
        },
        computed: {
            /**
             * 待采购处理的所有的订单信息
             */
            orders() {
                return this.applyOrdersData['orderList']
            },

            /**
             * 将 Vuex 中的数据映射到组件中
             */
            ...mapGetters(['applyOrdersData'])
        },
        methods: {
            /**
             * 点击 orderTable 上的
             * @row {Object} order 对象
             */
            clickMdf(row) {
                // 设置点击的行(order) 为当前正在处理的 currentOrder
                this.setCurrentApplyOrder(row)

                // 打开 currentOrder 编辑对话框
                this.componentManager.orderAMC.open()
            },

            /**
             * 初始化时加载订单数据
             */
            initOrders() {
                if (this.orders.length <= 0) {
                    this.loading = true
                    this.$getRequest(this.defaultUrl)
                        .then(response => {
                            this.handleResponse(response)
                            this.loading = false
                        })
                        .catch(error => {
                            this.loading = false
                        })
                }
            },

            /**
             * 处理响应数据,并更新响应数据到当前存储中
             * 会将原数据先清空
             * @param response 响应数据
             */
            setHandleResponse(response) {
                this.handleResponse(response, 'set')
            },

            /**
             * 处理响应数据
             */
            handleResponse({data,}, mod = 'add') {
                const handler = this.modHandleMap.get(mod)
                this.nextUrl = this.$utils.handleOrderUrl(data.next)
                const orders = data.results
                handler(orders)
                this.count = data.count
            },

            /**
             * 将 Vuex 的 mutations 映射到组件中
             */
            ...mapMutations(['addApplyOrders', 'setApplyOrders', 'setCurrentApplyOrder'])
        },
        created() {
            this.initOrders()
        },
        mounted() {
            // load orderApplyModifyComponent 到当前组件管理器中
            this.componentManager.orderApplyModifyComponent = this.$refs.orderApplyModify
            this.componentManager.orderAMC = this.componentManager.orderApplyModifyComponent
        }
    }
</script>

<style scoped>
</style>